export enum UserRoles {
  ADMIN = 'ADMIN',
  USER = 'USER',
  PREMIUM = 'PREMIUM',
  GUEST = 'GUEST',
}
